var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackBusinessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2001_26",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2001_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3346 15.166H0.667969C0.394635 15.166 0.167969 14.9393 0.167969 14.666C0.167969 14.3927 0.394635 14.166 0.667969 14.166H15.3346C15.608 14.166 15.8346 14.3927 15.8346 14.666C15.8346 14.9393 15.608 15.166 15.3346 15.166Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 15.1726C12.9142 15.1726 12.6875 14.9459 12.6875 14.6726V11.6992C12.6875 11.4259 12.9142 11.1992 13.1875 11.1992C13.4608 11.1992 13.6875 11.4259 13.6875 11.6992V14.6726C13.6875 14.9459 13.4675 15.1726 13.1875 15.1726Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.201 12.2005C12.1144 12.2005 11.2344 11.3205 11.2344 10.2338V8.72057C11.2344 7.63391 12.1144 6.75391 13.201 6.75391C14.2877 6.75391 15.1677 7.63391 15.1677 8.72057V10.2338C15.1677 11.3205 14.2877 12.2005 13.201 12.2005ZM13.201 7.76057C12.6677 7.76057 12.2344 8.19391 12.2344 8.72724V10.2405C12.2344 10.7738 12.6677 11.2072 13.201 11.2072C13.7344 11.2072 14.1677 10.7738 14.1677 10.2405V8.72724C14.1677 8.19391 13.7344 7.76057 13.201 7.76057Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5345 15.1659C9.26117 15.1659 9.0345 14.9392 9.0345 14.6659V4.01921C9.0345 2.95921 8.58784 2.50586 7.54784 2.50586H3.39453C2.34786 2.50586 1.89453 2.95921 1.89453 4.01921V14.6659C1.89453 14.9392 1.66786 15.1659 1.39453 15.1659C1.1212 15.1659 0.894531 14.9392 0.894531 14.6659V4.01921C0.894531 2.39921 1.7812 1.50586 3.39453 1.50586H7.54784C9.15451 1.50586 10.0345 2.39921 10.0345 4.01921V14.6659C10.0345 14.9392 9.80784 15.1659 9.5345 15.1659Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16719 6H3.86719C3.59385 6 3.36719 5.77333 3.36719 5.5C3.36719 5.22667 3.59385 5 3.86719 5H7.16719C7.44052 5 7.66719 5.22667 7.66719 5.5C7.66719 5.77333 7.44052 6 7.16719 6Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16719 8.5H3.86719C3.59385 8.5 3.36719 8.27333 3.36719 8C3.36719 7.72667 3.59385 7.5 3.86719 7.5H7.16719C7.44052 7.5 7.66719 7.72667 7.66719 8C7.66719 8.27333 7.44052 8.5 7.16719 8.5Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15.166C5.22667 15.166 5 14.9393 5 14.666V12.166C5 11.8927 5.22667 11.666 5.5 11.666C5.77333 11.666 6 11.8927 6 12.166V14.666C6 14.9393 5.77333 15.166 5.5 15.166Z",
    fill: "#5A5A5A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackBusinessIcon);
export default __webpack_public_path__ + "static/media/feedback-business-icon.3e4e11367340444e84dc2263acdb58f7.svg";
export { ForwardRef as ReactComponent };